"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var BaseApi_1 = tslib_1.__importDefault(require("../../API/BaseApi"));
var index_1 = require("../../Config/index");
var interfaces_1 = require("../authorize/interfaces");
var constants_1 = require("../authorize/constants");
function doSessionLog(kvp) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var url, response;
        return tslib_1.__generator(this, function (_a) {
            url = "".concat(index_1.sessionLogUrl, "?type=session&value=") + encodeURI(JSON.stringify(kvp));
            response = BaseApi_1.default.doPostRequestToChegg(url, kvp, { skipCsrfToken: true, loggedInState: interfaces_1.LoggedInState.SOFT }, 10000);
            return [2 /*return*/, response
                    .then(function (result) { return result.data; })
                    .catch(function (error) {
                    var apiError;
                    if (constants_1.AuthorizeErrors[error.message] !== undefined) {
                        apiError = constants_1.AuthorizeErrors[error.message];
                    }
                    else {
                        apiError = constants_1.AuthorizeErrors.UNKNOWN_FAILURE;
                    }
                    return {
                        errors: [apiError],
                        data: null,
                        success: false,
                    };
                })];
        });
    });
}
var logging = {
    doSessionLog: doSessionLog,
};
exports.default = logging;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/checkout-sdk/dist/lib-esm/modules/logging/index.js
// module id = 3394
// module chunks = 11